import { render, staticRenderFns } from "./ChatBotDemo.vue?vue&type=template&id=b257d9f4&scoped=true&"
import script from "./ChatBotDemo.vue?vue&type=script&lang=ts&"
export * from "./ChatBotDemo.vue?vue&type=script&lang=ts&"
import style0 from "./ChatBotDemo.vue?vue&type=style&index=0&id=b257d9f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b257d9f4",
  null
  
)

export default component.exports